import { useMemo } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import highlightQueryWords from "app/pages/sales-intelligence/modules/company-autocomplete/utils/highlightQueryWords";

import { StyledAIItem } from "./styles";

type Props = {
    text: string;
    searchTerm?: string;
    onClick: () => void;
};

export const AutocompleteAIItem = ({ text, searchTerm = "", onClick }: Props) => {
    const queryWords = useMemo(
        () =>
            searchTerm
                .split(" ")
                .map((word) => word.trim())
                .filter(Boolean),
        [searchTerm],
    );

    return (
        <StyledAIItem onClick={onClick}>
            <SWReactIcons
                iconName="ai-search"
                size="24px"
                iconColor={colorsPalettes.carbon[200]}
            />
            <Text fontVariant="input2">{queryWords.length > 0 ? highlightQueryWords(text, queryWords) : text}</Text>
        </StyledAIItem>
    );
};
